import { Variant } from '@alltrails/shared/components/forms/FormSelectorBase';
import { FilterViewModel, FilterConfigStarRating, FilterConfigToggle, FilterInput, Filters, FilterConfigRange } from 'types/Search';
import { StringConstantsMixin } from '../../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const pageStrings = StringConstantsMixin.strings.FILTERS;

const getFiltersConfigurations = (filters: Filters): FilterViewModel[] => [
  {
    display: 'Property',
    key: 'areas',
    enabledKey: 'area',
    type: FilterInput.CHECKBOX,
    truncate: true,
    config: filters.areas as FilterConfigToggle,
    extraProps: {
      variant: Variant.INLINE_INPUT_FIRST
    }
  },
  {
    display: pageStrings.LENGTH,
    key: 'lengths',
    enabledKey: 'length',
    type: FilterInput.RANGE,
    config: filters.lengths as FilterConfigRange
  },
  {
    display: pageStrings.DIFFICULTY,
    key: 'difficulty',
    enabledKey: 'difficulty',
    type: FilterInput.CHECKBOX,
    config: filters.difficulty as FilterConfigToggle,
    extraProps: {
      variant: Variant.INLINE_INPUT_FIRST
    }
  },
  {
    display: pageStrings.RATING,
    key: 'minRating',
    enabledKey: 'rating',
    type: FilterInput.STAR_RATING,
    config: filters.minRating as FilterConfigStarRating
  },
  {
    display: 'Alert type',
    key: 'alert_type',
    enabledKey: 'alert_type',
    type: FilterInput.CHECKBOX,
    config: filters.alert_type as FilterConfigToggle,
    extraProps: {
      variant: Variant.INLINE_INPUT_FIRST
    }
  }
];

export default getFiltersConfigurations;
